import React, { useEffect, useState } from "react";
import play from "../../../../assets/images/play.png";
import apple from "../../../../assets/images/apple.png";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import { useSelector, useDispatch } from "react-redux";
import {
  storeFname,
  storeLname,
  storeEmail,
  storePassword,
  storeConfirmPassword,
} from "../../../../formSlice";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function StepOne() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
    const user = localStorage.getItem("user");


  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [passwordConfirmationMessage, setPasswordConfirmationMessage] =
    useState("");
  const [password, setPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [fnameMessage, setFnameMessage] = useState("");
  const [lnameMessage, setLnameMessage] = useState("");
  const [emailValidated, setEmailValidated] = useState(false);
  const [passwordValidated, setPasswordValidated] = useState(false);
  const [passwordConfirmationValidated, setPasswordConfirmationValidated] =
    useState(false);
  const [hidePass, setHidePass] = useState(true);
  const [hideCPass, setHideCPass] = useState(true);
  const [dispatched, setDispatched] = useState(false);

  // Replace useNavigation with a simple navigation function for web.

  const form = useSelector((state) => state.gtm.form);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleSubmit = () => {
    if (fname) {
      dispatch(storeFname(fname));
      // localStorage.setItem("fname", fname);
    } else {
      setFnameMessage("First name is required.");
    }
    if (lname) {
      dispatch(storeLname(lname));
      // localStorage.setItem("lname", lname);
    } else {
      setLnameMessage("Family name is required.");
    }
    if (email) {
      dispatch(storeEmail(email));
      // localStorage.setItem("email", email);
    } else {
      setEmailMessage("Email is required.");
    }
    if (password) {
      dispatch(storePassword(password));
      // localStorage.setItem("password", password);
    } else {
      setPasswordMessage("Password is required.");
    }
    if (passwordConfirmation) {
      dispatch(storeConfirmPassword(passwordConfirmation));
      // localStorage.setItem("passwordConfirmation", passwordConfirmation);
    } else {
      setPasswordConfirmationMessage("Confirm your password.");
    }








    


    setDispatched(true);

    if (
      fname &&
      lname &&
      email &&
      password &&
      passwordConfirmation &&
      emailValidated &&
      passwordValidated &&
      passwordConfirmationValidated
    ) {


      navigate("/register/stepTwo");
    }
  };
  useEffect(() => {
    if (user) {
      navigate("/home"); // or your desired route
    }
  }, [user, navigate]);

  if (dispatched) {

  }
  const requiredIcon = () => {
    return (
      <span className="transform -translate-y-1/2 text-1xl text-[#ff0000]">
        *
      </span>
    );
  };
  return (
    <div
      className="flex flex-col gap-12"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
      }}
    >
      <div>
        <Nav />
      </div>

      <div className="flex items-center justify-center w-full mb-32">
        <div className="shadow-custom bg-white p-4 md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center mt-0 md:mt-2.5">
          <h3 className="text-2xl sm:text-3xl mb-6 sm:mb-8 text-center font-semibold text-black mx-auto">
            {t("step_one.register")}
          </h3>
          <div className="md:flex md:gap-4 mb-6">
            <div className="w-full flex flex-col items-start md:w-1/2 mb-4 md:mb-0">
              <div className="relative w-full">
                {/* <span className="absolute left-[65%] top-1/3 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                  *
                </span> */}
                <input
                  type="text"
                  value={fname}
                  onChange={(e) => setFname(e.target.value)}
                  className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
                  placeholder={t("step_one.first_name")}
                />
                {fnameMessage && (
                  <p className="text-red-500 text-xs text-start">
                    {fnameMessage}
                  </p>
                )}
              </div>
            </div>

            <div className="w-full flex flex-col items-start md:w-1/2 relative">
              <div className="relative w-full">
                {/* <span className="absolute left-[65%] top-1/3 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                  *
                </span> */}
                <input
                  type="text"
                  value={lname}
                  onChange={(e) => setLname(e.target.value)}
                  className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[500px] mx-auto block placeholder-[#A4A4A4]"
                  placeholder={t("step_one.family_name")}
                />
                {lnameMessage && (
                  <p className="text-red-500 text-xs text-start">
                    {lnameMessage}
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="mb-6 flex flex-col items-start">
            <div className="relative w-full">
              {/* <span className="absolute left-[60%] sm:left-[35%] top-1/3 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                *
              </span> */}
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Regex for domain validation
                  const domain = e.target.value.split("@")[1]; // Extract domain part of the email

                  switch (true) {
                    case e.target.value.length === 0:
                      setEmailMessage("Email is required.");
                      setEmailValidated(false);
                      break;

                    case !e.target.value.includes("@"):
                      setEmailMessage('Email must contain "@" symbol.');
                      setEmailValidated(false);
                      break;

                    case e.target.value.startsWith("@") ||
                      e.target.value.endsWith("@"):
                      setEmailMessage('Email cannot start or end with "@".');
                      setEmailValidated(false);
                      break;

                    case e.target.value.split("@").length > 2:
                      setEmailMessage('Email can only contain one "@" symbol.');
                      setEmailValidated(false);
                      break;

                    case !domain:
                      setEmailMessage("Email domain is missing.");
                      setEmailValidated(false);
                      break;

                    case !domainPattern.test(domain):
                      setEmailMessage("Email domain is invalid.");
                      setEmailValidated(false);
                      break;

                    default:
                      setEmailMessage("");
                      setEmailValidated(true);
                      break;
                  }
                  setEmail(e.target.value);
                }}
                className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[550px] mx-auto block placeholder-[#A4A4A4]"
                placeholder={t("step_one.email")}
              />
              {emailMessage && (
                <p className="text-red-500 text-xs text-start">
                  {emailMessage}
                </p>
              )}
            </div>
          </div>

          <div className="mb-6">
            <div className="relative">
              <div className="relative w-full">
                {/*  <span className="absolute left-[50%] sm:left-[30%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                  *
                </span> */}
                <input
                  type={hidePass ? "password" : "text"}
                  value={password}
                  onChange={(e) => {
                    if (e.target.value.length < 8) {
                      setPasswordMessage(
                        "Password should contain atleast 8 characters !"
                      );
                      setPasswordValidated(false);
                    } else {
                      setPasswordMessage("");
                      setPasswordValidated(true);
                    }
                    // if (e.target.value != passwordConfirmation) {
                    //   setPasswordMessage("Passwords should match !");
                    //   setPasswordValidated(false);
                    // } else {
                    //   setPasswordMessage("");
                    //   setPasswordValidated(true);
                    // }
                    setPassword(e.target.value);
                  }}
                  className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[550px] mx-auto block placeholder-[#A4A4A4]"
                  placeholder={t("step_one.password")}
                />
              </div>
              <button
                type="button"
                onClick={() => setHidePass(!hidePass)}
                className="absolute right-4 top-3.5 text-gray-500"
              >
                {hidePass ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                )}
              </button>
              {passwordMessage && (
                <p className="text-red-500 text-xs text-start">
                  {passwordMessage}
                </p>
              )}
            </div>
          </div>

          <div className="mb-8">
            <div className="relative">
              <div className="relative w-full">
                {/* <span className="absolute left-[58%] sm:left-[33%] top-1/2 transform -translate-y-1/2 text-1xl text-[#ff0000]">
                  *
                </span> */}
                <input
                  type={hideCPass ? "password" : "text"}
                  value={passwordConfirmation}
                  onChange={(e) => {
                    if (e.target.value.length < 8) {
                      setPasswordConfirmationMessage(
                        "Password should contain atleast 8 characters !"
                      );
                      setPasswordConfirmationValidated(false);
                    } else {
                      setPasswordConfirmationMessage("");
                      setPasswordConfirmationValidated(true);
                    }
                    if (e.target.value != password) {
                      setPasswordConfirmationMessage(
                        "Passwords should match !"
                      );
                      setPasswordConfirmationValidated(false);
                    } else {
                      setPasswordConfirmationMessage("");
                      setPasswordConfirmationValidated(true);
                    }
                    setPasswordConfirmation(e.target.value);
                  }}
                  className="bg-[#F4F5F9] border-none rounded-xl py-3 px-5 mb-3.5 w-full max-w-full sm:max-w-[550px] mx-auto block placeholder-[#A4A4A4]"
                  placeholder={t("step_one.confirm_password")}
                />
              </div>
              <button
                type="button"
                onClick={() => setHideCPass(!hideCPass)}
                className="absolute right-4 top-3.5 text-gray-500"
              >
                {hideCPass ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                  </svg>
                )}
              </button>
              {passwordConfirmationMessage && (
                <p className="text-red-500 text-xs text-start">
                  {passwordConfirmationMessage}
                </p>
              )}
            </div>
          </div>

          <div className="space-y-4">
            <button
              onClick={handleSubmit}
              type="submit"
              className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-black font-semibold border-none cursor-pointer mx-auto block hover:bg-[#333] text-white"
            >
              {language === "fr" ? "Suivant" : "Next"}
            </button>

            <div className="flex flex-col items-center gap-2 mt-[40px]">
              <p className="font-bold text-sm sm:text-base">
                {language === "fr"
                  ? "Vous avez déjà un compte?"
                  : "Already have an account?"}
              </p>
              <NavLink
                to="/login"
                className="w-full sm:max-w-[350px] py-3 text-base rounded-[33px] bg-[#00573f] font-semibold border-none cursor-pointer mx-auto block hover:opacity-80 text-white"
              >
                {language === "fr" ? "Connexion" : "Login"}
              </NavLink>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-1">
            <h6 className="mt-6 mb-4 text-center text-sm sm:text-base ">
              {t("login.download_app")} <br /> {t("login.p2")}
            </h6>
            <div className="flex justify-center gap-4">
              <NavLink
                to="https://apps.apple.com/ma/app/golf-trips-morocco/id6743395137"
                target="_blank"
              >
                <img
                  src={apple}
                  alt="App Store"
                  className="max-h-[40px] sm:max-h-[50px]"
                />
              </NavLink>
              <NavLink
                to="https://play.google.com/store/apps/details?id=com.golftripsmorocco.gtm"
                target="_blank"
              >
                <img
                  src={play}
                  alt="Google Play"
                  className="max-h-[40px] sm:max-h-[50px]"
                />
              </NavLink>
            </div>
          </div>

          {/* Footer Text */}
          {/* <div className="text-[7px] xs:text-xs sm:text-[12px] text-center text-[#666] pt-[40px]">
            {t("login.help_message")} <br className="hidden xs:block" />
            {language === "fr" ? "Voir les" : "See the"}{" "}
            <NavLink
              to="/termes-et-conditions"
              className="text-blue-500 no-underline hover:underline"
            >
              {language === "fr" ? "Conditions d'utilisation" : "Terms of Use"}
            </NavLink>
            ,{" "}
            <NavLink
              to="/conditions-de-notification"
              className="text-blue-500 no-underline hover:underline"
            >
              {language === "fr"
                ? "Conditions de notification"
                : "Notification conditions"}
            </NavLink>
            ,{" "}
            <NavLink
              to="/conditions-de-paiement"
              className="text-blue-500 no-underline hover:underline"
            >
              {language === "fr"
                ? "Conditions de paiement"
                : "Payment conditions"}
            </NavLink>
            {language === "fr" ? ", et la" : ", and"}{" "}
            <NavLink
              to="/politique-de-confidentialite"
              className="text-blue-500 no-underline hover:underline"
            >
              {language === "fr"
                ? "politique de confidentialité"
                : "Privacy Policy"}
            </NavLink>
            .
          </div> */}
        </div>
      </div>
    </div>
  );
}
